import React, { useState, useCallback } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ErrorBoundary from './components/ErrorBoundary';
import Overview from './pages/Overview';
import TenantOnboarding from './pages/TenantOnboarding';
import DriftMonitoring from './pages/DriftMonitoring';
import GovernanceFramework from './pages/GovernanceFramework';
import Settings from './pages/Settings';
import DiscoveryWorkshop from './pages/DiscoveryWorkshop';
import Login from './pages/Login';
import './App.css';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(() => {
    return !!localStorage.getItem('lz_token');
  });

  const handleLogin = useCallback(() => {
    setIsAuthenticated(true);
  }, []);

  const handleLogout = useCallback(() => {
    localStorage.removeItem('lz_token');
    localStorage.removeItem('lz_username');
    localStorage.removeItem('lz_auth_method');
    setIsAuthenticated(false);
  }, []);

  if (!isAuthenticated) {
    return (
      <ErrorBoundary>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login onLogin={handleLogin} />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <Layout onLogout={handleLogout}>
          <Routes>
            <Route path="/" element={<Overview />} />
            <Route path="/onboarding" element={<TenantOnboarding />} />
            <Route path="/drift" element={<DriftMonitoring />} />
            <Route path="/discovery-workshop" element={<DiscoveryWorkshop />} />
            <Route path="/gov-framework" element={<GovernanceFramework />} />
            <Route path="/settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
